import { SupportingDocumentSourceList } from '../../config/supportingDocument';
import { dataGridPremiumColumns } from '../../utils/helper';
import { DatagridPremiumUi } from '../Interface';
import { DataGridIdentifiers } from '../Interface/Datagrid/DataGridIdentifiers';

const SupportingDocumentTypeList = ({ rows, refetch, onSelect, isSaving, viewField, rowSelection }) => {
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Megnevezés',
      type: 'string',
      minWidth: 200,
      flex: 0.8,
    },
    {
      field: 'generated',
      headerName: 'Típus',
      type: 'string',
      minWidth: 130,
      valueGetter: (_value, row) => (row.generated ? 'Generált' : 'Külső'),
    },
    {
      field: 'prefix',
      headerName: 'Prefix',
      type: 'string',
      minWidth: 120,
    },
    {
      field: 'source',
      headerName: 'Forrás',
      type: 'string',
      minWidth: 180,
      valueGetter: (value) => SupportingDocumentSourceList[value] ?? '',
    },
    {
      field: 'note',
      headerName: 'Megjegyzés',
      type: 'string',
      minWidth: 220,
      flex: 1,
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.supportingDocumentType}
      dataLoader={refetch.getList}
      datagridInitialState={initialState}
      rows={rows}
      rowCount={rows.length}
      columns={[...columns]}
      refetch={{ refetchTable: refetch.refetchTable, setRefetchTable: refetch.setRefetchTable }}
      getRowId={(row) => row.id}
      onRowClick={(rowData) => onSelect(rowData.row.id)}
      paginationAndfilterMode="client"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default SupportingDocumentTypeList;
